import React, { useCallback, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { UnidataTable } from '~/components';
import { recordFiltering, refresh } from '~/store/modules/operacaooperstatusterminais/actions';

function OperacaoOperStatusTerminais() {
  const dispatch = useDispatch();


  const operacaooperstatusterminais = useSelector(
    (state) => state.operacaooperstatusterminais
  );

  const optionsEstados = useMemo(
    () => [
      { label: 1, value: 'Conectado' },
      { label: 2, value: 'Desconectado' },
    ],
    []
  );




  const header = React.useMemo(
    () => [
      {
        id: 'poco_descricao',
        label: 'Posto',
        filter: {
          type: 'text',
        },
        align: 'left',
        styled: (value) =>
          value.term_estado === 'Desconectado'
            ? { color: '#ff0000' }
            : { color: '#00B300' },
      },
      {
        id: 'term_identificacao',
        label: 'Terminal',
        filter: {
          type: 'text',
        },
        align: 'left',
        styled: (value) =>
          value.term_estado === 'Desconectado'
            ? { color: '#ff0000' }
            : { color: '#00B300' },
      },
      //styled: (v) => (v.dif_campo_auditoria_item === 'S' ? {  color: 'red' } : {}),
      {
        id: 'term_estado',
        label: 'Estado',
        filter: { type: 'select', options: optionsEstados },
        styled: (value) =>
          value.term_estado === 'Desconectado'
            ? { color: '#ff0000' }
            : { color: '#00B300' },
      },
      {
        id: 'term_ip',
        label: 'Endereço IP',
        align: 'left',
        styled: (value) =>
          value.term_estado === 'Desconectado'
            ? { color: '#ff0000' }
            : { color: '#00B300' },
      },
      {
        id: 'term_ult_conexao',
        label: 'Última comunicação',
        formatted: (value) =>
          value !== null ? moment(value).format('DD/MM/YYYY HH:mm') : '-',
        align: 'left',
        styled: (value) =>
          value.term_estado === 'Desconectado'
            ? { color: '#ff0000' }
            : { color: '#00B300' },
      },
      {
        id: 'term_intervalo_ult_conexao',
        label: 'Intervalo últ. comunicação',
        formatted: (value) =>
          value !== null ? moment(value).format('HH:mm:ss') : '-',
        align: 'left',
        styled: (value) =>
          value.term_estado === 'Desconectado'
            ? { color: '#ff0000' }
            : { color: '#00B300' },
      },
      {
        id: 'term_maior_intervalo_dia',
        label: 'Maior intevalo do dia',
        formatted: (value) =>
          value !== null ? moment(value).format('HH:mm:ss') : '-',
        align: 'left',
        styled: (value) =>
          value.term_estado === 'Desconectado'
            ? { color: '#ff0000' }
            : { color: '#00B300' },
      },
      {
        id: 'bicoAbastecendo',
        label: 'Bico Abastecendo',
        align: 'right',
        styled: (value) =>
          value.term_estado === 'Desconectado'
            ? { color: '#ff0000' }
            : { color: '#00B300' },
      },

      {
        id: 'bicoVazamento',
        label: 'Bico Vazamento',
        align: 'right',
        styled: (value) =>
          value.term_estado === 'Desconectado'
            ? { color: '#ff0000' }
            : { color: '#00B300' },
      },

      // {
      //   id: 'term_status_operacao',
      //   label: 'Operação',
      //   align: 'left',
      // },
      {
        id: 'term_versao_firmware',
        label: 'Versão Firmware',
        align: 'left',
        styled: (value) =>
          value.term_estado === 'Desconectado'
            ? { color: '#ff0000' }
            : { color: '#00B300' },
      },
    ],
    [optionsEstados]
  );


  useEffect(() => {
    const refreshTable = setInterval(() => {
      dispatch(refresh())
    }, 30000)
    return () => clearInterval(refreshTable)
  }, [])

  return (
    <>
      <UnidataTable

        reportOrder="poco_codigo ASC"
        create={false}
        delete={false}
        update={false}
        fixed
        header={header}
        redux={operacaooperstatusterminais}
        read={recordFiltering}
        detach="term_identificacao"
        view="vw_RetornaTerminalPosto"
        reportTitle="Status Terminal"
      />
    </>
  );
}

export default OperacaoOperStatusTerminais;
